import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const categoryData: Record<string, {
  name: string;
  description: string;
  icon: string;
  items: { id: number; title: string; category: string; rating: number; year: number; image: string; link: string }[];
}> = {
  movies: {
    name: '电影',
    description: '动作、喜剧、科幻、爱情、恐怖，各类大片尽在夜猫电影院',
    icon: 'ri-movie-2-line',
    items: [
      { id: 1, title: '流浪地球3', category: '科幻片', rating: 9.2, year: 2026, image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20futuristic%20space%20station%20and%20Earth%2C%20dramatic%20golden%20lighting%2C%20dark%20atmosphere%2C%20professional%20film%20poster%20design&width=600&height=800&seq=cat-movies-01&orientation=portrait', link: '/article/1' },
      { id: 2, title: '深海异兽', category: '动作片', rating: 8.7, year: 2026, image: 'https://readdy.ai/api/search-image?query=Underwater%20action%20movie%20poster%20with%20mysterious%20creature%2C%20dark%20blue%20cinematic%20atmosphere%2C%20thrilling%20film%20poster%20design&width=600&height=800&seq=cat-movies-02&orientation=portrait', link: '/article/3' },
      { id: 3, title: '夏夜星辰', category: '爱情片', rating: 8.5, year: 2026, image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20with%20starry%20night%20sky%2C%20warm%20golden%20lighting%2C%20soft%20romance%20film%20poster%20design&width=600&height=800&seq=cat-movies-03&orientation=portrait', link: '/article/4' },
      { id: 4, title: '鬼吹灯之昆仑神宫', category: '恐怖片', rating: 8.8, year: 2026, image: 'https://readdy.ai/api/search-image?query=Adventure%20horror%20movie%20poster%20with%20snowy%20mountain%20ruins%2C%20mysterious%20golden%20light%2C%20dark%20dramatic%20film%20poster&width=600&height=800&seq=cat-movies-04&orientation=portrait', link: '/article/5' },
      { id: 5, title: '极速追凶', category: '动作片', rating: 8.6, year: 2026, image: 'https://readdy.ai/api/search-image?query=Action%20thriller%20movie%20poster%20with%20car%20chase%20scene%2C%20dramatic%20night%20lighting%2C%20intense%20film%20poster%20design&width=600&height=800&seq=cat-movies-05&orientation=portrait', link: '/article/1' },
      { id: 6, title: '星河彼岸', category: '科幻片', rating: 9.0, year: 2026, image: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20with%20space%20exploration%20theme%2C%20nebulae%20and%20stars%2C%20epic%20cinematic%20design%2C%20dark%20cosmic%20background&width=600&height=800&seq=cat-movies-06&orientation=portrait', link: '/article/2' },
      { id: 7, title: '笑傲江湖2026', category: '喜剧片', rating: 8.3, year: 2026, image: 'https://readdy.ai/api/search-image?query=Comedy%20movie%20poster%20with%20bright%20playful%20elements%2C%20warm%20golden%20lighting%2C%20fun%20cinematic%20design%2C%20dark%20background&width=600&height=800&seq=cat-movies-07&orientation=portrait', link: '/article/3' },
      { id: 8, title: '暗夜追踪', category: '动作片', rating: 8.4, year: 2026, image: 'https://readdy.ai/api/search-image?query=Noir%20action%20movie%20poster%20with%20detective%20theme%2C%20dark%20rainy%20city%2C%20dramatic%20cinematic%20lighting%2C%20film%20poster&width=600&height=800&seq=cat-movies-08&orientation=portrait', link: '/article/4' },
    ],
  },
  'tv-series': {
    name: '电视剧',
    description: '热播国产剧、海外剧集，熬夜追剧不卡顿',
    icon: 'ri-tv-line',
    items: [
      { id: 1, title: '长安十二时辰', category: '古装剧', rating: 8.9, year: 2026, image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20poster%2C%20Tang%20Dynasty%20night%20cityscape%2C%20warm%20lantern%20lighting%2C%20epic%20TV%20series%20design&width=600&height=800&seq=cat-tv-01&orientation=portrait', link: '/article/2' },
      { id: 2, title: '大江大河3', category: '现代剧', rating: 9.0, year: 2026, image: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20drama%20poster%2C%20urban%20cityscape%20at%20dusk%2C%20warm%20golden%20tones%2C%20professional%20TV%20series%20design&width=600&height=800&seq=cat-tv-02&orientation=portrait', link: '/article/6' },
      { id: 3, title: '大明风华录', category: '古装剧', rating: 8.7, year: 2026, image: 'https://readdy.ai/api/search-image?query=Ming%20Dynasty%20historical%20drama%20poster%2C%20imperial%20palace%20at%20night%2C%20golden%20dragon%20motif%2C%20epic%20Chinese%20TV%20series&width=600&height=800&seq=cat-tv-03&orientation=portrait', link: '/article/1' },
      { id: 4, title: '迷雾追踪', category: '悬疑剧', rating: 8.6, year: 2026, image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20TV%20series%20poster%2C%20dark%20foggy%20city%2C%20investigation%20theme%2C%20cinematic%20suspense%20design&width=600&height=800&seq=cat-tv-04&orientation=portrait', link: '/article/5' },
      { id: 5, title: '青春不留白', category: '青春剧', rating: 8.4, year: 2026, image: 'https://readdy.ai/api/search-image?query=Youth%20drama%20poster%20with%20campus%20setting%2C%20warm%20nostalgic%20lighting%2C%20Chinese%20TV%20series%20design&width=600&height=800&seq=cat-tv-05&orientation=portrait', link: '/article/3' },
      { id: 6, title: '深海密码', category: '悬疑剧', rating: 8.8, year: 2026, image: 'https://readdy.ai/api/search-image?query=Underwater%20mystery%20thriller%20poster%2C%20dark%20ocean%20theme%2C%20cryptic%20symbols%2C%20cinematic%20suspense%20TV%20series&width=600&height=800&seq=cat-tv-06&orientation=portrait', link: '/article/4' },
      { id: 7, title: '食神2026', category: '都市剧', rating: 8.5, year: 2026, image: 'https://readdy.ai/api/search-image?query=Cooking%20drama%20poster%20with%20Chinese%20cuisine%2C%20warm%20restaurant%20lighting%2C%20food%20TV%20series%20design%2C%20dark%20background&width=600&height=800&seq=cat-tv-07&orientation=portrait', link: '/article/2' },
      { id: 8, title: '边疆风云', category: '军旅剧', rating: 8.9, year: 2026, image: 'https://readdy.ai/api/search-image?query=Military%20drama%20poster%20with%20border%20patrol%20theme%2C%20dramatic%20landscape%2C%20epic%20Chinese%20TV%20series%20design&width=600&height=800&seq=cat-tv-08&orientation=portrait', link: '/article/6' },
    ],
  },
  anime: {
    name: '动漫',
    description: '热血番剧、治愈动画，二次元的深夜时光',
    icon: 'ri-palette-line',
    items: [
      { id: 1, title: '星辰变·续', category: '玄幻', rating: 9.1, year: 2026, image: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20poster%20with%20cosmic%20cultivation%20theme%2C%20starry%20sky%2C%20golden%20energy%2C%20dark%20dramatic%20design&width=600&height=800&seq=cat-anime-01&orientation=portrait', link: '/article/1' },
      { id: 2, title: '夜幕猎人', category: '热血', rating: 8.8, year: 2026, image: 'https://readdy.ai/api/search-image?query=Action%20anime%20poster%20with%20night%20hunter%20theme%2C%20dark%20urban%20setting%2C%20dynamic%20combat%20pose%2C%20cinematic%20anime%20design&width=600&height=800&seq=cat-anime-02&orientation=portrait', link: '/article/3' },
      { id: 3, title: '樱花庄的故事', category: '治愈', rating: 9.0, year: 2026, image: 'https://readdy.ai/api/search-image?query=Slice%20of%20life%20anime%20poster%20with%20cherry%20blossoms%2C%20warm%20spring%20lighting%2C%20gentle%20atmosphere%2C%20dark%20background&width=600&height=800&seq=cat-anime-03&orientation=portrait', link: '/article/4' },
      { id: 4, title: '机甲纪元', category: '机甲', rating: 8.6, year: 2026, image: 'https://readdy.ai/api/search-image?query=Mecha%20anime%20poster%20with%20giant%20robot%2C%20futuristic%20city%2C%20dramatic%20explosive%20lighting%2C%20dark%20sci-fi%20design&width=600&height=800&seq=cat-anime-04&orientation=portrait', link: '/article/5' },
    ],
  },
  variety: {
    name: '综艺',
    description: '热门综艺、脱口秀，深夜欢乐不断',
    icon: 'ri-emotion-happy-line',
    items: [
      { id: 1, title: '深夜食堂·第六季', category: '美食综艺', rating: 9.3, year: 2026, image: 'https://readdy.ai/api/search-image?query=Food%20variety%20show%20poster%20with%20night%20kitchen%20scene%2C%20warm%20cozy%20dining%20atmosphere%2C%20golden%20lighting%2C%20dark%20background&width=600&height=800&seq=cat-variety-01&orientation=portrait', link: '/article/1' },
      { id: 2, title: '笑果脱口秀', category: '喜剧综艺', rating: 8.9, year: 2026, image: 'https://readdy.ai/api/search-image?query=Comedy%20talk%20show%20poster%20with%20stage%20spotlight%2C%20microphone%2C%20warm%20dramatic%20lighting%2C%20dark%20entertainment%20design&width=600&height=800&seq=cat-variety-02&orientation=portrait', link: '/article/2' },
      { id: 3, title: '荒野求生·星版', category: '户外综艺', rating: 8.7, year: 2026, image: 'https://readdy.ai/api/search-image?query=Survival%20variety%20show%20poster%20with%20wilderness%20adventure%20theme%2C%20dramatic%20nature%20landscape%2C%20dark%20cinematic%20design&width=600&height=800&seq=cat-variety-03&orientation=portrait', link: '/article/3' },
      { id: 4, title: '舞林争霸2026', category: '竞技综艺', rating: 8.5, year: 2026, image: 'https://readdy.ai/api/search-image?query=Dance%20competition%20show%20poster%20with%20dynamic%20movement%2C%20stage%20lighting%2C%20dramatic%20performance%20atmosphere%2C%20dark%20design&width=600&height=800&seq=cat-variety-04&orientation=portrait', link: '/article/4' },
    ],
  },
};

const subCategories: Record<string, string[]> = {
  movies: ['全部', '动作片', '喜剧片', '爱情片', '科幻片', '恐怖片', '纪录片'],
  'tv-series': ['全部', '古装剧', '现代剧', '悬疑剧', '青春剧', '都市剧', '军旅剧'],
  anime: ['全部', '热血', '玄幻', '治愈', '机甲', '搞笑', '恋爱'],
  variety: ['全部', '美食综艺', '喜剧综艺', '户外综艺', '竞技综艺', '音乐综艺'],
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeTab, setActiveTab] = useState('全部');
  const data = slug ? categoryData[slug] : null;
  const subs = slug ? subCategories[slug] || [] : [];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setActiveTab('全部');
  }, [slug]);

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-950">
        <div className="text-center">
          <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-800 mx-auto mb-4">
            <i className="ri-error-warning-line text-3xl text-foreground-500"></i>
          </div>
          <p className="text-foreground-500 text-lg">分类不存在</p>
          <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-400 text-sm">
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const filteredItems = activeTab === '全部'
    ? data.items
    : data.items.filter((item) => item.category === activeTab);

  return (
    <>
      <Helmet>
        <title>{`${data.name} - 夜猫电影院 | 高清在线观看`}</title>
        <meta name="description" content={`夜猫电影院${data.name}频道 - ${data.description}，深夜免费在线观看高清${data.name}。`} />
      </Helmet>

      <main className="min-h-screen bg-background-950 pt-16">
        <div className="bg-background-900 border-b border-background-700/30">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-600 mb-4">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-400">{data.name}</span>
            </nav>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-500/10">
                <i className={`${data.icon} text-2xl text-primary-500`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50">
                  {data.name}
                </h1>
                <p className="text-foreground-600 text-sm mt-1">{data.description}</p>
              </div>
            </div>

            {subs.length > 1 && (
              <div className="flex items-center gap-2 mt-6 flex-wrap">
                {subs.map((sub) => (
                  <button
                    key={sub}
                    onClick={() => setActiveTab(sub)}
                    className={`px-4 py-2 text-sm rounded-full transition-all cursor-pointer whitespace-nowrap ${
                      activeTab === sub
                        ? 'bg-primary-500 text-background-950 font-medium'
                        : 'bg-background-800 text-foreground-500 hover:text-foreground-200 hover:bg-background-700'
                    }`}
                  >
                    {sub}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {filteredItems.map((item) => (
              <Link
                key={item.id}
                to={item.link}
                className="group relative cursor-pointer"
              >
                <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 text-[10px] font-medium rounded bg-primary-500 text-background-950">
                      {item.rating}
                    </span>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-950">
                      <i className="ri-play-fill text-xl ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <h3 className="text-foreground-100 text-sm font-medium line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs mt-1">
                  {item.category} · {item.year}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </main>
    </>
  );
}